<div
  class="tabular-field-set__header"
  *ngIf="formControl.label || formControl.helpText"
>
  <app-launch-field-label
    class="tabular-field-set__label"
    *ngIf="formControl.label"
    [basespaceFormControl]="formControl"
  ></app-launch-field-label>
  <app-launch-field-help-text
    *ngIf="formControl.helpText"
    [helpText]="formControl.helpText"
  ></app-launch-field-help-text>
</div>

<app-launch-table
  [tableRowsControl]="formControl"
  [fields]="formControl.fields"
  [fieldCells]="formControl.fieldCells"
></app-launch-table>
